import { resetState, setLanguage } from '../context/appActions';
import { useApp } from '../context/appContext';
import { logoutUser } from '../context/kennoTenantActions';
import { useKennoTenantDispatch } from '../context/kennoTenantContext';

export const useLogout = () => {
  const kennoDispatch = useKennoTenantDispatch();
  const [{ language }, appDispatch] = useApp();

  function logout() {
    logoutUser(kennoDispatch);
    resetState(appDispatch);
    window.localStorage.clear();
    window.sessionStorage.clear();
    setLanguage(appDispatch, language);
  }

  return { logout };
};
